import request from '@/utils/request'

// 广告位置列表
export const listAdvertisementPosition = (pageData) => {
    return request.get(`/advertisementPosition/page/${pageData.page}/${pageData.pageSize}`);
};
